import {
  AgGrid,
  Page,
  withPermission,
} from '@logio/common-fe';
import { Observer } from 'mobx-react';
import * as React from 'react';
import { PageNamesEnum } from '../../../shared/localization/PageNamesEnum';
import ReleasePageHeader from './ReleasePageHeader';
import excelStyles from './excelStyles';
import { SelloutReleasePageStore } from '../../../stores/pages/Release/Overview/SelloutReleasePageStore';
import { PricingPermissions } from '@logio/common-be-fe';
import { PagePathsEnum } from '../../../shared/localization/PagePathsEnum';

/**
 * New page containing all (and only) regular and site releases.
 *
 * @author Jan Prokop
 */
export default function SelloutReleasePage() {
  const store = React.useMemo(() => new SelloutReleasePageStore(), []);

  React.useEffect(() => {
    store.load();
  }, [store]);

  const createPermissions = [
    PricingPermissions.SELLOUT_RELEASE_CREATE_OTHERS,
    PricingPermissions.SELLOUT_RELEASE_CREATE_URGENT,
  ];

  return (
    <Observer>
      {() => (
        <Page titleKey={PageNamesEnum.ReleasesSellout} loadingState={store.loadingState}>
          <ReleasePageHeader
            releaseStates={store.currentReleaseStates}
            onReleaseStateFilter={store.onReleaseStateFilter}
            newPath={withPermission(createPermissions, true) ? PagePathsEnum.ReleaseSelloutNew : null}
            impactPath={withPermission([PricingPermissions.IMPACT_REPORT_SELLOUT]) ? PagePathsEnum.ReleasesSelloutImpact : null}
          />
          <AgGrid
            rowData={store.rowData}
            columnDefs={store.columnDefs}
            excelStyles={excelStyles}
            gridId="SelloutReleasePage"
            quickView
            onGridReady={store.onGridReady}
          />
        </Page>
      )}
    </Observer>
  );
}
